import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { useDropzone } from "react-dropzone";
import axios from "axios";
// import secureLocalStorage from "react-secure-storage";
import { auth, db } from "../helper/firebaseClient";
import CircularProgress from "@mui/material/CircularProgress";
// import useAuth from "../stores/authStore";
import toast, { Toaster } from "react-hot-toast";
// import { api } from "../utils/axios-instance";
// import {
//   // sendEmailVerification,
//   // signInWithEmailAndPassword,
//   // updatePassword,
// } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";

import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const MAX_PROFILEPHOTO_SIZE = 1024 * 1024 * 2;

const OnboardingPage = () => {
  const [formData, setFormData] = useState({
    email: "",
    uid: "",
    tempPassword: "",
    password: "",
    username: "",
    department: "",
    firstName: "",
    lastName: "",
    profileUrl: "",
    profilePicture: null,
  });

  const [loading, setLoading] = useState(false);
  const [isPictureSelected, setIsPictureSelected] = useState(false);
  // const [departmentList, setDepartmentList] = useState([]);
  const [isFormComplete, setIsFormComplete] = useState(false);

  // const { setProfileData } = useAuth();

  const token = new URLSearchParams(window.location.search).get("token");

  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      navigate("/invalid-invite");
      return;
    }

    axios
      .post(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/validate-onboarding-token`,
        { token }
      )
      .then((res) => {
        const data = res.data;

        setFormData((prev) => ({
          ...prev,
          email: data.email,
          uid: data.uid,
          department: data.dept,
          tempPassword: data.tempPassword,
        }));
      })
      .catch((err) => {
        console.error("VALIDATE TOKEN ERROR:", err?.response?.data || err);
        navigate("/invalid-invite");
      });
  }, [token]);

  // useEffect(() => {
  //   const depData = async () => {
  //     try {
  //       const dep = await api.get(
  //         `${process.env.REACT_APP_BACKEND_BASE_URL}/dept/listDepts`
  //       );
  //       setDepartmentList(dep.data);
  //     } catch (error) {
  //       console.log("Error fetching departments");
  //     }
  //   };
  //   depData();
  // }, []);

  useEffect(() => {
    const { password, username, firstName, lastName, profilePicture } =
      formData;

    if (
      password.trim() &&
      username.trim() &&
      firstName.trim() &&
      lastName.trim() &&
      profilePicture
    ) {
      setIsFormComplete(true);
    } else {
      setIsFormComplete(false);
    }
  }, [formData]);

  const isFileSizeInLimit = (file) => {
    return file && file.size <= MAX_PROFILEPHOTO_SIZE;
  };

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      if (!isFileSizeInLimit(file)) {
        toast.error("File size is greater than allowed limit!");
        return;
      }

      setFormData((prev) => ({
        ...prev,
        profilePicture: file,
      }));
      setIsPictureSelected(true);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: { "image/*": [] },
    onDrop,
    maxFiles: 1,
  });

  const handleInputChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const uploadProfilePicture = async () => {
    const storage = getStorage();

    // use invite token as filename
    const filePath = `profile-pictures/onboarding/${token}-${Date.now()}.jpg`;

    const storageRef = ref(storage, filePath);

    await uploadBytes(storageRef, formData.profilePicture, {
      contentType: formData.profilePicture.type,
    });
    return await getDownloadURL(storageRef);
  };

  const handleNextButtonClick = async () => {
    setLoading(true);

    try {
      const profileUrl = await uploadProfilePicture();

      await axios.post(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/complete-onboarding`,
        {
          token,
          password: formData.password,
          username: formData.username,
          firstName: formData.firstName,
          lastName: formData.lastName,
          profileUrl,
        }
      );

      // toast.success(
      //   "Onboarding completed. Please verify your email before login."
      // );

      // AFTER complete-onboarding API success
      // 🔐 SIGN IN INVITED USER FIRST
      // const loginResult = await signInWithEmailAndPassword(
      //   auth,
      //   formData.email,
      //   formData.password
      // );

      // // 🔔 NOW send verification email
      // if (loginResult.user && !loginResult.user.emailVerified) {
      //   await sendEmailVerification(loginResult.user);
      //   toast.success("Verification email sent!");
      // }

      // console.log("LOGIN RESULT:", loginResult)

      toast.success(
        "Onboarding completed. You can now login."
      );

      await auth.signOut();
      navigate("/login");
    } catch (error) {
      console.error("Onboarding error:", error);
      toast.error(error.response?.data?.error || "Onboarding failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-between items-center">
      {/* Header */}
      <div className="flex items-center justify-between w-full px-2 md:px-4 lg:px-8 py-4 border-b-2">
        <a href="/">
          <div className="flex items-center space-x-2">
            <img
              src="/twokey-logo.svg"
              alt="Logo"
              className="h-6 w-6 text-[#1E1B66]"
            />
            <span className="text-xl font-allertaStencil text-[#1E1B66]">
              TWOKEY
            </span>
          </div>
        </a>
      </div>

      <Toaster position="bottom-left" reverseOrder={false} />

      {/* MAIN SECTION */}
      <div className="text-center p-16">
        <strong className="text-5xl font-raleway">Welcome to TwoKey</strong>
        <p className="text-lg text-gray-400 my-2">
          A secured file sharing platform for companies
        </p>

        {/* FORM (single long panel) */}
        <form className="my-16 shadow-lg rounded-lg p-8 w-[60vw] text-left">
          {/* Email */}
          <div className="mb-6">
            <label className="block text-gray-600 text-sm font-medium p-1">
              Email *
            </label>
            <input
              type="email"
              className="block w-full border rounded-md py-2 px-3"
              value={formData.email}
              disabled
            />
          </div>

          {/* Password */}
          <div className="mb-6">
            <label className="block text-gray-600 text-sm font-medium p-1">
              Password *
            </label>
            <input
              type="password"
              className="block w-full border rounded-md py-2 px-3"
              placeholder="Enter your password"
              value={formData.tempPassword}
              // readOnly
              onChange={(e) =>
                handleInputChange("tempPassword", e.target.value)
              }
            />
          </div>

          {/* New Password */}
          <div className="mb-6">
            <label className="block text-gray-600 text-sm font-medium p-1">
              New Password *
            </label>
            <input
              type="password"
              className="block w-full border rounded-md py-2 px-3"
              placeholder="Enter your password"
              value={formData.password}
              onChange={(e) => handleInputChange("password", e.target.value)}
            />
          </div>

          {/* Profile Picture */}
          <div className="mb-6">
            <label className="block text-gray-600 text-sm font-medium p-1">
              Profile Picture{" "}
              <span className="text-xs text-red-500">
                up to {MAX_PROFILEPHOTO_SIZE / 1024 / 1024} MBs
              </span>
            </label>

            {isPictureSelected ? (
              <img
                src={URL.createObjectURL(formData.profilePicture)}
                alt="Profile Pic"
                className="mt-2 max-h-40 max-w-full rounded-md"
              />
            ) : (
              <div
                {...getRootProps()}
                className="mt-2 h-28 w-32 hover:text-blue-400 flex items-center justify-center border-2 border-dashed hover:border-blue-400 border-gray-400 p-4 rounded-md text-center cursor-pointer"
              >
                <input {...getInputProps()} />
                <p>Drop files to upload</p>
              </div>
            )}
          </div>

          {/* Username */}
          <div className="mb-6">
            <label className="block text-gray-600 text-sm font-medium p-1">
              Username *
            </label>
            <input
              type="text"
              className="block w-full border rounded-md py-2 px-3"
              placeholder="Enter your username"
              value={formData.username}
              onChange={(e) => handleInputChange("username", e.target.value)}
            />
          </div>

          {/* First / Last Name */}
          <div className="grid grid-cols-1 md:grid-cols-2 md:gap-4">
            <div className="mb-6">
              <label className="block text-gray-600 text-sm font-medium p-1">
                First Name *
              </label>
              <input
                type="text"
                className="block w-full border rounded-md py-2 px-3"
                placeholder="Enter your first name"
                value={formData.firstName}
                onChange={(e) => handleInputChange("firstName", e.target.value)}
              />
            </div>

            <div className="mb-6">
              <label className="block text-gray-600 text-sm font-medium p-1">
                Last Name *
              </label>
              <input
                type="text"
                className="block w-full border rounded-md py-2 px-3"
                placeholder="Enter your last name"
                value={formData.lastName}
                onChange={(e) => handleInputChange("lastName", e.target.value)}
              />
            </div>
          </div>
        </form>
      </div>

      {/* FOOTER */}
      <footer className="fixed bottom-0 left-0 w-full py-4 text-right p-16 bg-gray-50 bg-opacity-10 backdrop-blur-sm flex justify-between items-center border">
        <Typography variant="p" className="text-sm text-gray-400">
          TwoKey © 2023
        </Typography>
        <button
          type="submit"
          onClick={() => handleNextButtonClick()}
          className={`rounded-md py-2 px-8 text-white bg-blue-700 ${
            (!isFormComplete || loading) && "opacity-20 cursor-not-allowed"
          }`}
          disabled={!isFormComplete || loading}
        >
          {loading ? (
            <CircularProgress
              style={{ color: "white", height: 25, width: 25 }}
            />
          ) : (
            "Next"
          )}
        </button>
      </footer>
    </div>
  );
};

export default OnboardingPage;
